import { MenuItem } from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../../localization/i18n';

/**
 * MenuItem component that allows the user to change the application language.
 */
export default (props: { lang: string }) => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'header' });
    
    /** Deconstruct props. */
    const { lang } = props;

    /**
     * Callback that sets the application language.
     */
    const handleChangeLang = useCallback(() => i18n.changeLanguage(lang), [lang]);

    return <MenuItem onClick={handleChangeLang}>{t(lang)}</MenuItem>;
};
